export default __webpack_public_path__ + "static/media/a024-startup-3.2018263c.svg";